import _createClass from "@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import AfsTableWrapper from '../shared/AfsTableWrapper';
import PropTypes from 'prop-types';
import { matchingTypeAnswerSummaryPropType } from '../../../common/propTypes';
import t from '@instructure/quiz-i18n/es/format-message';
import { AfsPartsContainer } from '../shared/AfsPartsContainer/presenter';
import MatchingTypeTable from './MatchingTypeTable';
import AggregationTable from '../shared/AggregationTable';
var distractorKey = 'distractor';
export var CategorizationType = /*#__PURE__*/function (_Component) {
  function CategorizationType() {
    var _this;
    _classCallCheck(this, CategorizationType);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, CategorizationType, [].concat(args));
    _defineProperty(_this, "updateAnswerBody", function (answerSummary) {
      var answerSummaryCopy = _objectSpread({}, answerSummary);
      Object.keys(answerSummaryCopy.questions).forEach(function (questionKey) {
        Object.keys(answerSummaryCopy.questions[questionKey].answers).forEach(function (answerKey) {
          if (distractorKey === answerKey) {
            var detail = answerSummaryCopy.questions[questionKey].answers[answerKey];
            answerSummaryCopy.questions[questionKey].answers[answerKey] = _objectSpread(_objectSpread({}, detail), {}, {
              body: t('Distractors')
            });
          }
        });
      });
      return answerSummaryCopy;
    });
    _defineProperty(_this, "render", function () {
      var _this$props = _this.props,
        itemId = _this$props.itemId,
        answerSummary = _this$props.answerSummary;
      var updatedAnswerSummary = _this.updateAnswerBody(answerSummary);
      return /*#__PURE__*/React.createElement(AfsTableWrapper, {
        noAnswerMissingPopover: true
      }, /*#__PURE__*/React.createElement(AfsPartsContainer, {
        afsTable: /*#__PURE__*/React.createElement(MatchingTypeTable, {
          itemId: itemId,
          answerSummary: updatedAnswerSummary,
          firstColumnName: t('Answer')
        }),
        aggregationTable: /*#__PURE__*/React.createElement(AggregationTable, {
          itemId: itemId,
          answerSummary: updatedAnswerSummary
        })
      }));
    });
    return _this;
  }
  _inherits(CategorizationType, _Component);
  return _createClass(CategorizationType);
}(Component);
_defineProperty(CategorizationType, "propTypes", {
  itemId: PropTypes.number.isRequired,
  answerSummary: matchingTypeAnswerSummaryPropType.isRequired
}.isRequired);